import { Clickable, Icon, Row } from 'components';
import { useOutsideClick } from 'core';
import mime from 'mime';
import React, { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';

/*
  Example usage:

  <MediaModal media={media}>
    <PreviewImg src={media} />
  </MediaModal>
*/
const MediaModal = ({ media, forceVideo, children }) => {
  const [visible, setVisible] = useState(false),
    [current, setCurrent] = useState(0),
    [uri, setUri] = useState(null),
    contentRef = useRef(null),
    { isMobile } = useSelector((state) => state.appState);

  media = Array.isArray(media) ? media[0].uri : media;
  const isVideo = mime.getType(media)?.includes('video') || forceVideo;

  useOutsideClick(contentRef, handleVisible);

  function handleVisible() {
    setVisible(!visible);

    if (visible) {
      setCurrent(0);
      setUri(null);
    }
  }

  return (
    <React.Fragment>
      <Clickable noFlex onClick={handleVisible}>
        {children}
      </Clickable>

      {visible && (
        <Row
          pos="fixed"
          top="0"
          left="0"
          bg="rgba(0, 0, 0, 0.5)"
          wid="100vw"
          ht="100vh"
          zIndex="10"
          onClick={handleVisible}
          centerAll
        >
          <Clickable onClick={handleVisible} zIndex={10}>
            <Row
              pos="fixed"
              right="24px"
              top="24px"
              pad="10px"
              hasRadius="32px"
              hasBorder="2px solid #fff"
            >
              <Icon type="close" col="#fff" dimensions={14} />
            </Row>
          </Clickable>

          <Row contentRef={contentRef}>
            {isVideo ? (
              <ReactPlayer
                width={isMobile ? '100vw' : 936}
                height="100vh"
                url={media}
                controls
                playing
              />
            ) : (
              <img
                src={media}
                style={{
                  width: 936,
                  marginTop: 24,
                  marginBottom: 24,
                  maxHeight: 'calc(100vh - 48px)',
                  objectFit: 'contain'
                }}
              />
            )}
          </Row>
        </Row>
      )}
    </React.Fragment>
  );
};

export default MediaModal;
